module.exports = __webpack_public_path__ + "static/media/icPromptPublished.4683d4c3.svg";